/// <reference types="vite/client" />

// Determine if we should use mock data
const baseUseMockData =
  import.meta.env.VITE_USE_MOCK_DATA === 'true' ||
  import.meta.env.VITE_USE_MOCK_DATA === true ||
  !import.meta.env.VITE_SUPABASE_URL ||
  import.meta.env.VITE_SUPABASE_URL === ''

const isProduction = import.meta.env.PROD

let resolvedUseMockData = baseUseMockData

if (!resolvedUseMockData && isProduction) {
  const requiredEnvVars = ['VITE_SUPABASE_URL', 'VITE_SUPABASE_ANON_KEY'] as const

  const hasMissingSupabaseConfig = requiredEnvVars.some((envVar) => {
    const value = import.meta.env[envVar]
    return !value || value === 'https://placeholder.supabase.co' || value === 'placeholder-key'
  })

  if (hasMissingSupabaseConfig) {
    console.warn(`⚠️  VITE_SUPABASE_URL/VITE_SUPABASE_ANON_KEY not configured - using mock data`)
    resolvedUseMockData = true
  }
}

export const env = {
  supabase: {
    url: import.meta.env.VITE_SUPABASE_URL || '',
    anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || '',
  },
  app: {
    env: import.meta.env.VITE_APP_ENV || 'development',
    version: import.meta.env.VITE_APP_VERSION || '0.1.0',
    name: import.meta.env.VITE_APP_NAME || 'IgrejaDigital',
    useMockData: resolvedUseMockData,
  },
  isDevelopment: import.meta.env.DEV,
  isProduction,
} as const
